import request from '@/utils/request';
import Cookies from 'js-cookie';

const ALL_COMPANIES = -1;

const downloadLogoRequest = id =>
  request.get(`/company/logo/${id}`, {
    responseType: 'blob'
  });

const deleteLogoRequest = id => request.delete(`/company/logo/${id}`);

export const storeExtensions = {
  actions: {
    setCurrentCompanyID({ commit }, companyID) {
      commit('SET_CURRENT_COMPANY', companyID);
    },
    clearCurrentCompanyID({ commit }) {
      commit('SET_CURRENT_COMPANY', 0);
    },
    selectAllCompanies({ commit }) {
      commit('SET_CURRENT_COMPANY', ALL_COMPANIES);
    },
    downloadLogo({ dispatch }, id) {
      return downloadLogoRequest(id);
    },
    deleteLogo({ dispatch }, id) {
      return deleteLogoRequest(id);
    }
  },
  getters: {
    getCurrentCompanyID(state) {
      return +state.currentCompanyID;
    },
    userLinkedCompanies(state, getters, rootState, rootGetters) {
      const linkedCompanyIDs = rootGetters.linkedCompanyIDs;
      return state.items.filter(c => linkedCompanyIDs.includes(c.id));
    },
    ALL_COMPANIES() {
      return ALL_COMPANIES;
    }
  },
  mutations: {
    SET_CURRENT_COMPANY: (state, currentCompanyID) => {
      state.currentCompanyID = currentCompanyID;
      if (currentCompanyID >= 0 || currentCompanyID === ALL_COMPANIES) {
        Cookies.set('currentCompanyID', currentCompanyID);
      } else {
        Cookies.remove('currentCompanyID');
      }
    }
  },
  state: {
    ALL_COMPANIES,
    currentCompanyID: +Cookies.get('currentCompanyID') || ''
  }
};
